import React from 'react';
import FeaturedArticle from '../molecules/FeaturedArticle';
import { newsItems as allNewsItems } from '../../data/newsItems';

const NewsSection = ({
  title = 'Recent News & Achievements',
  subtitle = "Stay updated with DataRook's latest activities, partnerships, and community impact.",
  items = allNewsItems,
  limit,
  className = '',
}) => {
  const visibleItems = limit ? items.slice(0, limit) : items;
  const featuredItems = visibleItems.filter((item) => item.featured);
  const otherItems = visibleItems.filter((item) => !item.featured);

  return (
    <section className={`py-16 md:py-20 bg-gray-50 ${className}`.trim()}>
      <div className="dr-container">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-4">{title}</h2>
        <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">{subtitle}</p>

        {featuredItems.map((item) => (
          <div key={item.id || item.link} className="mb-12 max-w-4xl mx-auto">
            <FeaturedArticle
              title={item.title}
              excerpt={item.excerpt}
              link={item.link}
              featured
            />
          </div>
        ))}

        {otherItems.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {otherItems.map((item) => (
              <FeaturedArticle
                key={item.id || item.link}
                title={item.title}
                excerpt={item.excerpt}
                link={item.link}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsSection;
